<template>
 <d-row>
   <d-col lg="4">
       <d-card class="card-small mb-4 pt-3">
 
    <!-- Card Header -->
    <d-card-header class="border-bottom text-center">
 
      <!-- User Avatar -->
      <div class="mb-3 mx-auto">
        <img class="rounded-circle" src="@/assets/images/avatars/0.jpg" width="110">
      </div>
    
      <!-- User Name -->
      <h4 class="mb-0">{{ user.firstName }} {{ user.lastName }}</h4>
 
      <!-- User Job Title -->
      <span class="text-muted d-block mb-2">Staff</span>
    </d-card-header>
  </d-card>
   </d-col>
   <d-col lg="8">
  <d-card class="card-small mb-4">
 
    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <h6 class="m-0">{{ title }}</h6>
    </d-card-header>
 
    <d-list-group flush>
      <d-list-group-item class="p-3">
          <d-col>
            <d-form>
              <d-form-row>
                <!-- First Name -->
                <d-col md="6" class="form-group">
                  <label for="feFirstName">First Name</label>
                  <d-form-input type="text" id="feFirstName" placeholder="First Name" v-model="user.firstName"/>
                </d-col>
                
                <!-- Last Name -->
                <d-col md="6" class="form-group">
                  <label for="feLastName">Last Name</label>
                  <d-form-input type="text" id="feLastName" placeholder="Last Name" v-model="user.lastName"/>
                </d-col>
 
              </d-form-row>
 
              <d-form-row>
                <!-- Phone -->
                <d-col md="12" class="form-group">
                  <label for="phoneNumber">Phone Number</label>
                  <d-form-input type="text" id="phoneNumber" placeholder="Phone Number" v-model="user.phone"/>
                </d-col>
 
                <!-- Email -->
                <d-col md="12" class="form-group">
                  <label for="feEmail">Email</label>
                  <d-form-input type="email" id="feEmail" placeholder="Email Address" v-model="user.email" readonly/>
                </d-col>
              </d-form-row>
              <d-button type="submit" class="btn-accent" @click.prevent="update()">Update Account</d-button>
            </d-form>
          </d-col>
      </d-list-group-item>
    </d-list-group>
  </d-card>
  </d-col>
 </d-row>

</template>
 
<script>
import axios from "axios";

export default {
  name: 'user-account-details',
  data() {
    return {
      user : []
    };
  },
  props: {
    /**
     * The component title.
     */
    title: {
      type: String,
      default: 'Account Details',
    },
  },
  mounted: function () {
    axios
      .get(process.env.VUE_APP_API+'api/user/Profile')
      .then(response => {
        this.user = response.data.result;
        // console.log(response.data);
      })
      .catch(function (error) {
        //console.log(error);
      });
  },
  methods: {
    update() {
      axios.put(process.env.VUE_APP_API+'api/user/Profile',{
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        gender: "None",
        phone: this.user.phone,
      })
    }
  }
};
</script>